export const WEBCHAT = 'webChat';
export const LAB = 'lab';
export const ACCOUNT_MANAGEMENT = 'accountManagement';
export const WORKING_CALENDAR = 'wokingCalendar';
